import React from "react";
import { ServiceAddon, ServiceAddonStatusCode } from "../services/service-addon-service";

interface ServiceAddonDetailModalProps {
  rowName: string;
  data?: ServiceAddon;
  loading: boolean;
  onClose: () => void;
}

const formatStatus = (status?: ServiceAddonStatusCode): { label: string; color: string } => {
  switch (status) {
    case ServiceAddonStatusCode.ACTIVE:
      return { label: "Hoạt động", color: "text-green-600 bg-green-50 border-green-400" };
    case ServiceAddonStatusCode.INACTIVE:
      return { label: "Ngưng hoạt động", color: "text-amber-600 bg-amber-50 border-amber-400" };
    case ServiceAddonStatusCode.DELETED:
      return { label: "Đã xóa", color: "text-red-600 bg-red-50 border-red-400" };
    default:
      return { label: "Không xác định", color: "text-slate-500 bg-slate-50 border-slate-300" };
  }
};
const formatDateTime = (dateString?: string): string => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const ServiceAddonDetailModal: React.FC<ServiceAddonDetailModalProps> = ({
  rowName,
  data,
  loading,
  onClose,
}) => {
  const status = formatStatus(data?.status);

  const detailItems = [
    { label: "Tên dịch vụ phụ", value: data?.name ?? rowName },
    { label: "Mã dịch vụ phụ", value: data?.code ?? "-" },
    { label: "Chi nhánh", value: data?.branch_id ? `Store #${data.branch_id}` : "-" },
    {
      label: "Trạng thái",
      value: (
        <span
          className={`inline-block rounded-full border px-3 py-1 text-xs font-medium ${status.color}`}
        >
          {status.label}
        </span>
      ),
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm px-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white shadow-xl border border-slate-200 animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-200 p-5">
          <h2 className="text-lg font-semibold text-slate-800">Chi tiết dịch vụ phụ</h2>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-full w-8 h-8 flex items-center justify-center transition"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {loading ? (
            <div className="flex justify-center py-10">
              <span className="h-10 w-10 animate-spin rounded-full border-4 border-green-500 border-t-transparent"></span>
            </div>
          ) : (
            <>
              {/* Info grid */}
              <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {detailItems.map((item) => (
                  <div
                    key={item.label}
                    className="rounded-lg border border-slate-100 bg-slate-50 p-4"
                  >
                    <dt className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      {item.label}
                    </dt>
                    <dd className="mt-1 text-sm font-medium text-slate-800">{item.value}</dd>
                  </div>
                ))}
              </dl>

              {/* Description */}
              <div className="mt-5 rounded-lg border border-slate-100 bg-slate-50 p-4">
                <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Mô tả dịch vụ phụ
                </h3>
                <p className="mt-2 text-sm text-slate-700">
                  {data?.description ?? "Chưa có mô tả cho dịch vụ phụ này."}
                </p>
              </div>

              {/* Dates */}
             {/* Dates */}
            <dl className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="rounded-lg border border-slate-100 bg-slate-50 p-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Ngày tạo
                </dt>
                <dd className="mt-1 text-sm font-medium text-slate-800">
                  {formatDateTime(data?.created_at)}
                </dd>
              </div>
              <div className="rounded-lg border border-slate-100 bg-slate-50 p-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Ngày cập nhật
                </dt>
                <dd className="mt-1 text-sm font-medium text-slate-800">
                  {formatDateTime(data?.updated_at)}
                </dd>
              </div>
            </dl>

            </>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-slate-200 p-4 text-right">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg bg-slate-100 text-slate-700 text-sm font-medium hover:bg-slate-200 transition"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceAddonDetailModal;
